export default "__VITE_ASSET__BD$MRX_b__"